import clsx from 'clsx';
import React, { forwardRef } from 'react';

type BaseTextAreaProps = React.HTMLProps<HTMLTextAreaElement> & {
  round?: string;
};

export const BaseTextArea = forwardRef<HTMLTextAreaElement, BaseTextAreaProps>(
  ({ className, round, ...props }, ref) => (
    <div className="relative">
      <textarea
        ref={ref}
        className={clsx(
          'block w-full appearance-none border border-gray-300 py-2 shadow-sm placeholder:text-gray-400 focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm',
          round,
          'pr-4',
          className
        )}
        {...props}
      />
    </div>
  )
);

BaseTextArea.displayName = 'BaseTextArea';
